var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"parallax-hero"}},[_c('base-parallax',{attrs:{"height":500,"src":"https://cdn.vuetifyjs.com/images/parallax/material.jpg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }